import { DatabaseId, getOptions, VerificationStep } from '@sheerid/jslib';

export const getFieldsToCollectUrl = (verificationId: DatabaseId, stepName: VerificationStep) => `${getOptions().restApi.serviceUrl}rest/v2/verification/${verificationId}/${stepName}/fields`;
